module.exports = __webpack_public_path__ + "img/book-solid.c5d9388d.svg";